import axios from "axios";
import Kjur from "../utils/jwt";

const bearerToken = Kjur.encode(
    JSON.parse(localStorage.getItem("userDetails"))
);

let axiosConfig = {
    headers: {
        "Content-Type": "application/json; charset=UTF-8",
        "Access-Control-Allow-Origin": "*",
        "Strict-Transport-Security": "max-age=90",
        Authorization: `Bearer ${bearerToken}`,
    },
};

// City (Location) APIs

export const fetchLocations = async (data) => {
    const obj = { page: data.page, limit: data.limit, keyword: data.keyword };
    const encodedData = Kjur.encode(obj);

    return await axios.get(
        `${process.env.REACT_APP_API_BASE_URL}/admin/locations?token=${encodedData}`,
        axiosConfig
    );
};

export const addLocation = async (location) => {
    const data = {
        name: location.name,
        // Add other fields if necessary
    };
    const encodedData = Kjur.encode(data);

    return await axios.post(
        `${process.env.REACT_APP_API_BASE_URL}/admin/locations`,
        { token: encodedData },
        axiosConfig
    );
};

export const editLocation = async (location) => {
    const data = {
        id: location.id,
        name: location.name,
    };
    const encodedData = Kjur.encode(data);

    return await axios.put(
        `${process.env.REACT_APP_API_BASE_URL}/admin/locations/update`,
        { token: encodedData },
        axiosConfig
    );
};

export const deleteLocation = async (locationId) => {
    const data = { id: locationId };
    const encodedData = Kjur.encode(data);

    return await axios.delete(
        `${process.env.REACT_APP_API_BASE_URL}/admin/locations/delete?token=${encodedData}`,
        axiosConfig
    );
};

// District APIs

export const fetchDistricts = async (locationId) => {
    const obj = { location_id: locationId };
    const encodedData = Kjur.encode(obj);

    return await axios.get(
        `${process.env.REACT_APP_API_BASE_URL}/admin/locations/districts/get-location-districts?token=${encodedData}`,
        axiosConfig
    );
};

export const addDistrict = async (district) => {
    const data = {
        location_id: district.locationId,
        name: district.name,
    };
    const encodedData = Kjur.encode(data);

    return await axios.post(
        `${process.env.REACT_APP_API_BASE_URL}/admin/locations/districts`,
        { token: encodedData },
        axiosConfig
    );
};

export const editDistrict = async (district) => {
    const data = {
        id: district.districtId,
        location_id: district.locationId,
        name: district.districtName,
    };
    const encodedData = Kjur.encode(data);

    return await axios.put(
        `${process.env.REACT_APP_API_BASE_URL}/admin/locations/districts/update`,
        { token: encodedData },
        axiosConfig
    );
};

export const deleteDistrict = async (districtId) => {
    const data = { id: districtId };
    const encodedData = Kjur.encode(data);

    return await axios.delete(
        `${process.env.REACT_APP_API_BASE_URL}/admin/locations/districts/delete?token=${encodedData}`,
        axiosConfig
    );
};
